(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cadisen-announcement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cadisen-marquee')){
customElements.define('cadisen-marquee',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();const signal=this.abort.signal;
this.viewport=this.querySelector('.cd-announcement__messages');
this.track=this.querySelector('.cd-marquee__track');
this.group=this.querySelector('.cd-marquee__group');
this.button=this.querySelector('[data-pause]');
this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.button.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},{signal});
this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync();},{signal});
this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync();},{signal});
this.addEventListener('focusin',()=>{this.focused=true;this.sync();},{signal});
this.addEventListener('focusout',()=>{this.focused=false;this.sync();},{signal});
this.addEventListener('shopify:block:select',e=>{
const item=[...this.group.children].find(x=>x.dataset.blockId===e.detail.blockId);
if(item&&this.animation){this.paused=true;this.sync();this.animation.currentTime=(item.offsetLeft-this.group.offsetLeft)/Number(this.dataset.speed||45)*1000;}
},{signal});
this.observer=new ResizeObserver(()=>this.build());this.observer.observe(this.viewport);this.observer.observe(this.group);
document.fonts.ready.then(()=>{if(this.isConnected)this.build();});this.build();
}
build(){
this.animation?.cancel();
this.track.querySelectorAll('[data-copy]').forEach(x=>x.remove());
const width=this.group.getBoundingClientRect().width;if(!width)return;
const count=Math.ceil(this.viewport.clientWidth/width)+1;
for(let i=0;i<count;i++){const clone=this.group.cloneNode(true);clone.dataset.copy='true';clone.setAttribute('aria-hidden','true');clone.inert=true;clone.querySelectorAll('[data-shopify-editor-block]').forEach(x=>x.removeAttribute('data-shopify-editor-block'));this.track.append(clone);}
this.animation=this.track.animate([{transform:'translateX(0)'},{transform:'translateX(-'+width+'px)'}],{duration:width/Number(this.dataset.speed||45)*1000,iterations:Infinity,easing:'linear'});this.sync();
}
sync(){if(this.animation){if(this.paused||this.hovered||this.focused)this.animation.pause();else this.animation.play();}
this.button.innerHTML=this.paused?'<svg class="cd-ui-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m8 5 11 7-11 7Z"/></svg>':'<svg class="cd-ui-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5v14M15 5v14"/></svg>';this.button.setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);}
disconnectedCallback(){this.animation?.cancel();this.observer?.disconnect();this.abort?.abort();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cadisen-collection-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cadisen-collections')) {
 customElements.define('cadisen-collections', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController(); const signal = this.abort.signal;
   this.track = this.querySelector('[data-track]');
   this.prev = this.querySelector('[data-prev]'); this.next = this.querySelector('[data-next]');
   const move = direction => {
    const card = this.track.querySelector('[data-card]');
    if(card) this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0)), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   };
   this.prev.addEventListener('click',()=>move(-1),{signal});
   this.next.addEventListener('click',()=>move(1),{signal});
   this.track.addEventListener('scroll',()=>this.update(),{signal,passive:true});
   this.addEventListener('shopify:block:select',e=>{
    const card=[...this.querySelectorAll('[data-card]')].find(c=>c.dataset.blockId===e.detail.blockId);
    if(card) this.track.scrollTo({left:card.offsetLeft-this.track.offsetLeft,behavior:'auto'});
   },{signal});
   this.resize = new ResizeObserver(()=>this.update()); this.resize.observe(this.track); this.update();
  }
  update(){this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;}
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cadisen-fullscreen-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cadisen-rotator')) {
  customElements.define('cadisen-rotator', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1), {signal});
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1), {signal});
      this.toggle = this.querySelector('[data-pause]');
      this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); }, {signal});
      this.addEventListener('mouseenter', () => this.hovered = true, {signal});
      this.addEventListener('mouseleave', () => this.hovered = false, {signal});
      this.addEventListener('shopify:block:select', e => {
        const index = this.items.findIndex(x => x.dataset.blockId === e.detail.blockId);
        if (index >= 0) { this.show(index); this.paused = true; this.updateToggle(); }
      }, {signal});
      this.show(0); this.updateToggle();
      const firstImage = this.items[0]?.querySelector('img');
      const prepareNext = () => { if(this.isConnected) this.prepare(1); };
      if(firstImage?.complete) prepareNext();
      else firstImage?.addEventListener('load', prepareNext, {once:true, signal});
      if (this.items.length > 1 && this.dataset.autoplay !== 'false') {
        this.timer = setInterval(() => {
          if (!this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) this.move(1);
        }, Number(this.dataset.interval || 5) * 1000);
      }
      this.querySelectorAll('[data-multi]').forEach(x => x.hidden = this.items.length < 2);
    }
    prepare(index) {
      const img=this.items[index % this.items.length]?.querySelector('img');
      if(img){img.fetchPriority='low';img.loading='eager';}
    }
    show(index) {
      const current=this.items[index]?.querySelector('img');
      if(current) current.loading='eager';
      this.index = index;
      this.items.forEach((item, i) => { item.hidden = i !== index; item.inert = i !== index; });
      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = (index + 1) + ' / ' + this.items.length;
      if(index>0) this.prepare(index+1);
    }
    async move(step) {
      if(!this.items.length || this.loading) return;
      const next=(this.index+step+this.items.length)%this.items.length;
      const image=this.items[next].querySelector('img');
      this.loading=true;
      try {
        if(image){image.loading='eager';await image.decode();}
        if(this.isConnected) this.show(next);
      } catch(error) {
        if(image?.naturalWidth && this.isConnected) this.show(next);
      } finally {this.loading=false;}
    }
    updateToggle() {
      if (this.toggle) {
        this.toggle.innerHTML = this.paused ? '<svg class="cd-ui-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m8 5 11 7-11 7Z"/></svg>' : '<svg class="cd-ui-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5v14M15 5v14"/></svg>';
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();
})();
